$ ->
  # Enable placeholder support for ie9
  $("input, textarea").placeholder()
